



import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { Editor } from 'tiptap';

@Component({
  components: {},
})
export default class ProsemirrorWrapper extends Vue {
  @Prop() editor: Editor;
  @Watch('editor') loadEditor() {
    if (this.editor?.element) {
      this.$nextTick(() => {
        this.$el.appendChild(this.editor.element.firstChild);
        this.editor.setParentComponent(this);
        this.$emit('loaded');
      });
    }
  }

  beforeDestroy() {
    if (this.editor) {
      this.editor.element = this.$el;
    }
  }
}
